import { Component, OnInit, Input } from '@angular/core';
import { FiltroService } from './../../../../shared/filtro/filtro.service';
import { ListitemBuilder } from './../../../../shared/dropdown-list/ListItemBuilder';

@Component({
  selector: 'app-boxes-filtro',
  templateUrl: './boxes-filtro.component.html',
  styleUrls: ['./boxes-filtro.component.css']
})
export class BoxesFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor(private servico: FiltroService) { }

  dealers = [];
  ano: any;
  mes: any;

  ngOnInit() {
    this.preencherDealers();
    this.carregaAno();
    this.carregaMes();
  }

  preencherDealers() {
    this.servico.buscar('dealer')
      .then(r => { this.dealers = r.filtros; });
  }

  set Dealer(id: any) { this.filtros.id_dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.id_dealer); }

  set Ano(id: any) { this.filtros.ano = this.tratarSetDropDown(id); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.ano); }

  set Mes(id: any) { this.filtros.mes = this.tratarSetDropDown(id); }
  get Mes(): any { return this.tratarGetDropDown(this.filtros.mes); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }


  selecionaDealer() {
    this.dealers = [];

    this.preencherDealers();
  }

  private carregaAno() {
    this.ano =
      new ListitemBuilder()
        .add(2018, 2018)
        .add(2019, 2019)
        .add(2020, 2020)
        .add(2021, 2021)
        .add(2022, 2022)
        .add(2023, 2023)
        .build();
  }

  private carregaMes() {
    this.mes =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  limparFiltros() {
    this.Dealer = '';
    this.Ano = '';
    this.Mes = '';
  }
}
